import * as React from 'react';
import DashboardView from '~/components/DashboardView';
import { t } from '~/i18n';
import UserNotifications from '~/containers/UI/UserNotifications';

const dashboardWrapper: (Page, title?: string, rightComponent?: any) => any =
  (Page, title, rightComponent) => (props) => {
    React.useEffect(() => {
      if (title) {
        document.title = t('meta.title', { title });
      }
    }, [title]);

    return (
      <>
        <DashboardView title={title} rightComponent={rightComponent}>
          <UserNotifications>
            <Page {...props} />
          </UserNotifications>
        </DashboardView>
      </>
    );
  };
export default dashboardWrapper;
